export const TR = {
  ua: {
    brand: "E-PISNYA",
    tagline: "Твоя історія перетвориться на пісню",
    hero_headline_1: "Створюй пісні,",
    hero_headline_hl: "під будь яку подію",
    hero_line2: "під будь яку подію",
    hero_line3: "",
    tariffs_title: "ТИСНИ НА СВІЙ ВАРІАНТ",
    tariffs_sub: "Три способи створити вашу пісню",
    plan_team_label: "ЗРОБИТЬ ПРОФЕСІОНАЛ",
    plan_team_title: "НАША СТУДІЯ",
    plan_team_price: "1999 грн",
    plan_team_desc: "Команда професійних композиторів та звукорежисерів зробить для вас власноруч: кілька варіантів тексту і кілька варіантів звучання в різних жанрах та голосах.",
    plan_bot_label: "ТЕЛЕГРАМ-БОТ",
    plan_bot_title: "СТВОРИ ЧЕРЕЗ TELEGRAM-ЗАСТОСУНОК",
    plan_bot_price: "169 грн 🔥",
    plan_bot_desc: "Перейди в телеграм, та створи свою пісню в зручному застосунку за декілька кліків!",
    plan_site_label: "СТВОРИ НА САЙТІ",
    plan_site_title: "СТВОРИ ПРЯМО ТУТ",
    plan_site_price: "199 грн",
    plan_site_desc: "Створіть прямо тут! Наш конструктор автоматично згенерує пісню, яку ви зможете скачати на сайті, або ми відправимо пісню у будь-який месенджер (Telegram, Viber, WhatsApp, Instagram) або на e-mail.",
    plan_click: "Натисни",
    plan_eta_bot: "Виготовлення до 5 хв",
    plan_eta_team: "до 24 годин",
    plan_eta_site: "Виготовлення до 10 хв",
    sounds_title: "ВАРІАНТИ ЗВУЧАННЯ",
    benefits: [
      { icon: "⚡", t: "Готово\nдо 5 хвилин" },
      { icon: "🎵", t: "Будь-який\nстиль" },
      { icon: "❤️", t: "Ідеально\nдля подарунка" },
    ],
    startup_badge: "Український технологічний стартап",
    unites: "Музика об'єднує",
    nav_how: "Як це працює",
    nav_examples: "Приклади",
    nav_pricing: "Тарифи",
    nav_reviews: "Відгуки",
    nav_admin: "Адмін",
    nav_cta: "Запустити бота",
    nav_create: "Створити",
    nav_instruction: "Інструкція",
    hero_badge: "хітів уже створено",
    hero_title_1: "Створи свій хіт",
    hero_title_hl: "в один клік",
    hero_sub: "Тексти · Музика · Голос · Готовий трек",
    hero_cta: "Запустити бота",
    hero_cta_song: "Створити пісню",
    hero_note_left: "Більше української музики 💛",
    hero_note_right: "Твої емоції мають звук 💙",
    create: {
      cta_sub: "Займе всього 2 хвилини",
      modal_title: "Обери варіант",
      modal_sub: "Два способи створити вашу пісню",
      dev_title: "Команда створить за вас",
      dev_desc: "Наша команда створить пісню за вас — ви лише опишіть ідею. Готовий трек надішлемо вам.",
      dev_price: "699 грн",
      dev_badge: "під ключ",
      dev_eta: "Результат через годину",
      bot_title: "Створю сам у боті",
      bot_desc: "Відкрийте бота та пройдіть 5 простих кроків — опис пісні, музика, вокал.",
      bot_price: "169 грн",
      bot_badge: "самостійно",
      step_of: "Крок {n} із 4",
      step_of8: "Крок {n} із 8",
      back: "Назад",
      next: "Далі",
      b_ev_title: "З якою нагодою пісня?",
      b_ev_sub: "Оберіть привід",
      b_ev_custom_ph: "Напр. пісня для сестри",
      b_genre_title: "Оберіть стиль музики",
      b_genre_sub: "Оберіть жанр",
      b_genre_more: "Додаткові жанри",
      b_genre_mix: "Мікс 2 жанрів",
      b_genre_custom: "Свій стиль / виконавець",
      b_mix_title: "Оберіть 2 жанри для міксу",
      b_mix_sub: "Виберіть рівно два — вони зіллються в один стиль",
      b_mix_done: "Готово",
      b_custom_title: "Свій стиль або виконавець",
      b_custom_sub: "Напишіть, як має звучати пісня — напр. «як Океан Ельзи»",
      b_custom_ph: "Напр. «щось тепле під гітару, як у 90-х»",
      b_mood_title: "Яким має бути настрій?",
      b_mood_sub: "Оберіть настрій",
      b_mood_custom: "Свій настрій",
      b_mood_custom_ph: "Запальний, злий",
      b_lang_title: "Якою мовою заспівати?",
      b_lang_sub: "Оберіть мову пісні",
      b_voice_title: "Який вокал бажаєте?",
      b_voice_sub: "Оберіть голос",
      b_recommend: "Рекомендуємо",
      b_row_event: "Привід",
      b_row_genre: "Жанр",
      b_row_mood: "Настрій",
      b_row_lang: "Мова",
      sound_title: "Оберіть звучання",
      sound_sub: "Який настрій і стиль має бути у вашій пісні?",
      sounds: [
        { t: "Зворушлива лірика", d: "Лірична, зворушлива пісня під сучасну гітару з чітким вокалом — до мурах." },
        { t: "Поп (універсально)", d: "Може бути як зворушлива із сучасними бітами, так і танцювальна в машину чи колонку — підходить майже під усе." },
        { t: "R&B", d: "Мелодійна та зворушлива, але більш співоча й сучасна — м'який грув і теплий вокал." },
        { t: "Танцювальна", d: "Під цю музику хочеться танцювати — драйвовий біт і святкова енергія." },
        { t: "Застільна", d: "Теплі пісні для веселощів і посиденьок із друзями — мелодійні, з народними мотивами." },
        { t: "Легкий рок", d: "Чоловічий вайб, стримана сила й адреналін — для чоловіків, військових, тих, хто любить посильніше. Без агресії." },
        { t: "Рок", d: "Гітарний драйв, живі барабани й енергія — помітно потужніше за легкий рок, але без агресії." },
        { t: "Реп / хіп-хоп", d: "Качовий біт і читка — сучасно, ритмічно, з характером." },
        { t: "Діп-хаус", d: "Спокійна клубна музика для ночі — м'який бас, глибокий вайб і атмосфера." },
        { t: "Дісней", d: "Казкова, кінематографічна пісня, як у мультфільмі — для дітей і мрійників." },
        { t: "Диско / ню-диско", d: "Запальне диско — як на дискотеці 80-х: грув, яскраві синтезатори й святкова енергія." },
      ],
      vo_title: "Оберіть виконавця",
      vo_sub: "Чий голос співатиме вашу пісню?",
      voices: [
        { t: "Чоловічий", d: "Міцний чоловічий вокал" },
        { t: "Жіночий", d: "Ніжний жіночий вокал" },
        { t: "Дует", d: "Чоловічий і жіночий разом" },
      ],
      desc_title: "Розкажіть про пісню",
      desc_sub: "Напишіть у вільній формі, для кого та про що повинна бути пісня. Від цього тексту залежить якість пісні. Можна додати історію, імена та будь-що інше.",
      desc_own_title: "Ваш текст",
      desc_own_sub: "Вставте готовий текст пісні. Усе, що ви напишете, буде проспівано дослівно.",
      desc_gen_note: "Система згенерує текст пісні на основі вашого опису.",
      desc_ph: "Наприклад: пісня для мами на день народження. Вона все життя присвятила нам із братом, любить сад і вишиванки, найбільше щастя для неї — коли ми всі разом...",
      desc_lang_hint: "Заспіваємо тією мовою, якою ви напишете опис",
      desc_example_btn: "Показати приклад",
      desc_example_hide: "Сховати приклад",
      desc_example: "«Пісня для моєї дружини Ані на 30 років. Ми разом 8 років, у нас донька Соломія. Аня — моя опора, обожнює море і каву вранці. Хочу подякувати їй за терпіння і сказати, що кохаю сильніше з кожним днем.»",
      story_attach: "Скриншот історії",
      story_change: "Змінити",
      story_remove: "Прибрати",
      checkout_title: "Майже все",
      checkout_sub: "Залишилось зовсім трішки",
      co_sound: "Звучання",
      co_brief: "Про пісню",
      co_total: "Сума до оплати",
      price200: "199 грн",
      co_eta: "Орієнтовний час очікування пісні",
      co_eta_value: "до 10 хв",
      tier_title: "Оберіть швидкість виконання",
      tier_standard: "Стандарт",
      tier_standard_eta: "24 години",
      tier_standard_price: "699 грн",
      tier_express: "Ускорений",
      tier_express_eta: "6 годин",
      tier_express_price: "999 грн",
      tier_urgent: "Терміновий",
      tier_urgent_eta: "1 година",
      tier_urgent_price: "1599 грн",
      co_delivery: "Куди надіслати пісню?",
      co_required: "обов'язково",
      co_delivery_hint: "Оберіть зручний спосіб — email, Telegram, WhatsApp, Viber або Instagram. Залиште контакт, куди надіслати готову пісню.",
      methods: { telegram: "Telegram", whatsapp: "WhatsApp", viber: "Viber", email: "Email", instagram: "Instagram" },
      contact_ph: {
        telegram: "@username або +380 67 123 45 67",
        whatsapp: "+380 67 123 45 67",
        viber: "+380 67 123 45 67",
        email: "you@email.com",
        instagram: "@your_nickname",
      },
      co_show: "Розгорнути",
      co_hide: "Згорнути",
      co_edit: "Редагувати",
      co_details_title: "Деталі замовлення",
      co_confirm: "Підтверджую",
      err_contact: "Вкажіть, куди надіслати пісню.",
      err_phone: "Невірний номер. Лише цифри, напр. +380 67 123 45 67",
      err_email: "Невірний email, напр. you@email.com",
      err_telegram: "Вкажіть Telegram-нік (напр. @username) або номер телефону.",
      err_instagram: "Вкажіть Instagram-нік, напр. @your_nickname",
      studio_title: "Обробка замовлення",
      studio_sub: "Передаємо замовлення в студію…",
      support_cta: "Є питання? Пиши",
      guarantee_q: "Якщо пісня не підійде?",
      guarantee_a: "Наша команда професіоналів робить на совість, але якщо хоча б якась деталь не підійшла — ми безкоштовно переробимо для вас.",
      pay_title: "МАЙЖЕ ВСЕ - ОПЛАТА!",
      pay_sub: 'Перекажіть суму на нашу картку, прикріпіть скріншот чека та натисніть "СПЛАЧЕНО", наша команда почне створювати пісню!',
      pay_amount: "Сума до оплати",
      pay_card: "Картка для оплати",
      copy: "Копія",
      copied: "Скопійовано ✓",
      loading_card: "Завантажуємо реквізити…",
      wallet_title: "ОПЛАТА",
      wallet_sub: "Оберіть Apple Pay або Google Pay — це швидко й безпечно.",
      wallet_choose: "Як вам зручніше оплатити?",
      wallet_processing: "Обробляємо платіж…",
      wallet_processing_sub: "Це займе кілька секунд.",
      wallet_error_title: "Тимчасові труднощі з платежем",
      wallet_error_text: "Не хвилюйтеся — ваша пісня не загубиться. Залиште email, і ми зв'яжемося з вами, щоб почати виробництво пісні.",
      wallet_contact_btn: "Зв'язатися з нами",
      wallet_form_title: "Залиште контакт",
      wallet_form_sub: "Ми напишемо вам і почнемо створення пісні.",
      wallet_form_email: "Ваш email",
      wallet_form_message: "Коментар (необов'язково)",
      wallet_form_ph: "Наприклад: хочу пісню для мами...",
      wallet_form_send: "Надіслати",
      wallet_form_sending: "Надсилаємо…",
      wallet_form_note: "Відповідаємо протягом 30 хвилин у робочий час.",
      wallet_sent_title: "Дякуємо!",
      wallet_sent_text: "Ми отримали ваш контакт і зв'яжемося з вами, щоб почати створення пісні.",
      wallet_err_email: "Вкажіть коректний email.",
      wallet_err_message: "Коментар має містити мінімум 10 символів.",
      wallet_err_send: "Не вдалося надіслати. Спробуйте ще раз.",
      pay_receipt: "Скріншот оплати",
      receipt_pick: "Прикріпити чек (натисни сюди)",
      receipt_change: "Змінити чек",
      receipt_hint: "Фото, скріншот або PDF квитанції (до 10 МБ)",
      submit: "Я сплатив(а)",
      submitting: "Надсилаємо…",
      summary_sound: "Звучання",
      err_desc: "Опишіть пісню детальніше — мінімум 25 символів.",
      err_receipt: "Будь ласка, прикріпіть скріншот оплати.",
      err_send: "Не вдалося надіслати замовлення. Спробуйте ще раз.",
      done_title: "Дякуємо!",
      done_sub: "Ваше замовлення прийнято",
      done_order: "Замовлення №",
      done_note: "Ми перевіримо оплату та одразу почнемо створення вашої пісні. Зробіть скрін цієї сторінки з номером замовлення. Статус замовлення можна відстежувати прямо на сайті — внизу з'явиться панель зі статусом, яка оновлюється автоматично.",
      done_close: "Закрити",
      done_contact: "Зв'язатись з нами",
    },
    pills: [
      { t: "Без знань і досвіду" },
      { t: "Будь-який стиль" },
      { t: "Для свят і подарунків" },
      { t: "Твої ідеї стають піснями" },
    ],
    sp_songs: "пісень створено",
    sp_rating: "рейтинг задоволення",
    sp_tears: "сліз щастя",
    sp_speed: "хв на створення",
    how_title: "Як це працює",
    how_sub: "Від ідеї до готової пісні — за 5 кроків",
    how_steps: [
      { t: "Обери привід і стиль", d: "5 простих кроків: привід, жанр, настрій, мова та голос." },
      { t: "Отримай текст БЕЗКОШТОВНО", d: "ІІ напише персональний текст пісні за пару хвилин." },
        { t: "Послухай приклади", d: "Реальні пісні наших користувачів — прямо на сайті." },
      { t: "Оплати зручно", d: "Переказ на картку та підтвердження — і генерація запускається." },
      { t: "Отримай готову пісню", d: "Повний трек у 2 варіантах, та в високій якості." },
    ],
    ex_title: "Послухай приклади",
    ex_sub: "Кожен хіт — унікальна історія",
    examples: [
      { tag: "🎷 R&B", title: "Що таке E-PISNYA", genre: "R&B",
        desc: "Наша візитівка — як ідея перетворюється на пісню за пару хвилин.",
        img: "/hero-pc.jpg", audio: "/episnya.mp3", pos: "object-top", review: "" },
      { tag: "🪕 Під гітару", title: "Привітання мамі на 60", genre: "Під гітару",
        desc: "Тепла пісня-подяка мамі за все, що вона віддала.",
        img: "/examples/3.jpg", audio: "/examples/3.mp3",
        review: "Пісня розчулила всіх за столом — навіть тата. ДУЖЕ дякую!" },
      { tag: "🎸 Рок", title: "Підтримка брату-військовому", genre: "Рок",
        desc: "Потужний рок для того, хто на передовій — про силу, віру й дім, який чекає.",
        img: "/examples/2.jpg", audio: "/examples/2.mp3",
        review: "Братан вже дома) Пісня на репіті" },
      { tag: "🎸 Гітара", title: "Освідчення", genre: "Під гітару",
        desc: "Тиха пісня під гітару зі словами, які хочеться сказати назавжди.",
        img: "/examples/1.jpg", audio: "/examples/1.mp3",
        review: "Вона сказала ТАК — і це головне для мене. Дякую вам!)" },
      { tag: "🎷 R&B", title: "Викриття зради", genre: "R&B",
        desc: "Повільний R&B про біль, правду й гідність — від хлопця до дівчини.",
        img: "/examples/4.jpg", audio: "/examples/4.mp3",
        review: "Ми розійшлися, але це було красиво 😄" },
      { tag: "💃 Танцювальна + EDM", title: "Привітання куму-пожежнику", genre: "Танцювальна + EDM",
        desc: "Драйвова танцювальна з енергією EDM — веселе привітання з гумором.",
        img: "/examples/5.jpg", audio: "/examples/5.mp3",
        review: "Пісня сподобалась, на гулянці грала разів 50! НЕ МЕНШЕ)" },
    ],

    ex_play: "Слухати",
    ex_playing: "Грає 🎧",
    pricing_title: "Обери свій пакет",
    pricing_sub: "Більше генерацій — вигода до 46%. Подумай про майбутні свята заздалегідь.",
    pricing_popular: "Найпопулярніший",
    pricing_cta: "Обрати в боті",
    pricing_features: ["Безкоштовний текст", "Студійна якість", "Ваша власна пісня", "Генерація до 5хв"],
    creators_btn: "🎬 Для креаторів",
    creators_title: "Для креаторів і бізнесу",
    creators_sub: "Великі пакети генерацій — для студій, агенцій та тих, хто створює пісні на замовлення.",
    creators_cta: "Обговорити в боті",
    sticky_cta: "Створити пісню",
    referral_title: "Партнерська програма",
    referral_sub: "Заробляйте як повноцінний партнер проєкту — 50% від доходу з кожної покупки ваших рефералів. Розмістіть посилання будь-де: соцмережі, блог, реклама.",
    referral_cta: "Стати партнером",
    reviews_title: "Що кажуть клієнти",
    reviews_leave: "Залишити відгук",
    reviews_empty: "Тут скоро з'являться відгуки наших клієнтів…",
    review_modal_title: "Ваш відгук",
    review_modal_sub: "Поділіться враженнями — відгук з'явиться на сайті після модерації.",
    review_name_ph: "Ваше ім'я",
    review_text_ph: "Яка вийшла пісня? Що сподобалось?",
    review_send: "Надіслати",
    review_sent_title: "Дякуємо!",
    review_sent_text: "Ваш відгук відправлено на модерацію — незабаром він з'явиться на сайті.",
    review_err_name: "Вкажіть ім'я (мінімум 2 символи)",
    review_err_text: "Напишіть відгук (мінімум 10 символів)",
    review_err_send: "Не вдалося надіслати, спробуйте ще раз",
    review_close: "Закрити",
    last_creation: "Ваше останнє створення",
    last_orders_title: "Ваші замовлення",
    last_hint: "Продовжити з того місця, де ви зупинились",
    last_continue: "Продовжити",
    last_open_song: "Відкрити пісню",
    st_unpaid: "не оплачено",
    st_pending: "на перевірці",
    st_generating: "генерується",
    st_paid: "виконується студією",
    st_done: "виконано",
    st_expired: "прострочено",
    st_rejected: "відхилено",
    quality_title: "Гарантії якості",
    quality_sub: "Ми поруч на кожному кроці, від ідеї до готової пісні",
    quality: [
      { icon: "regen", t: "Перегенеруємо безкоштовно", d: "Якщо щось не так, ми завжди підемо на поступки і перегенеруємо пісню безкоштовно якнайшвидше." },
      { icon: "bot", t: "Бот на штучному інтелекті", d: "Зручний бот зробить все за вас: від тексту до готової пісні з вокалом." },
      { icon: "support", t: "Підтримка завжди онлайн", d: "Якщо щось незрозуміло, служба підтримки на зв'язку та допоможе вирішити будь-яке питання." },
      { icon: "person", t: "Допоможемо особисто", d: "Ми готові особисто згенерувати для вас пісню та допомогти на кожному етапі. Просто напишіть у підтримку бота." },
    ],
    quality_slogan: "Для нас клієнт на першому місці",
    faq_title: "Часті питання",
    faq: [
      { q: "Якою мовою буде пісня?", a: "Українською та будь-якою іншою мовою. Ти обираєш під час створення або просиш згенерувати текст потрібною мовою. Бот все розуміє та заспіває мовою тексту пісні." },
      { q: "Скільки часу займає створення?", a: "Текст — пару хвилин, готовий трек з вокалом — до 3 хвилин." },
      { q: "Чи можу я скачати пісню?", a: "Так, після оплати ти отримуєш пісню прямо в чат телеграм." },
      { q: "Чи можна замовити обкладинку або листівку?", a: "Так, для всіх клієнтів ми можемо зробити листівку з вашим фото або з фото отримувача. Безкоштовно при покупці пісні." },
      { q: "А якщо трек не сподобався або сталась помилка?", a: "Наш бот генерує дуже якісні пісні. Але якщо з піснею щось не так, чи вам не сподобався жанр, слова або музика, напишіть у підтримку. Ми перегенеруємо з вашими побажаннями безкоштовно." },
      { q: "Я не знаю, який жанр підійде. Що робити?", a: "У боті під кожну подію є підказка з найпопулярнішими жанрами. Але ви можете експериментувати або запитати у підтримки." },
      { q: "Мені подобається певний артист. Чи можна зробити пісню в його стилі?", a: "Так. На етапі вибору жанру оберіть «Свій стиль / виконавець» і просто вкажіть ім'я артиста, у стилі якого хочете пісню. Бот автоматично підбере звучання." },
      { q: "У мене є свої слова. Чи можна з них зробити пісню?", a: "Так, ви можете написати свої слова. Бот їх підправить та згенерує з ними повноцінний текст, який буде звучати." },
      { q: "А якщо в мене немає слів?", a: "Просто опишіть, про що має бути трек. Наприклад факти: ім'я, секрети, особисті моменти, які хочете почути в пісні. Все інше за нами." },
      { q: "Кому належать права?", a: "Пісня створена для тебе — даруй, діли, публікуй у соцмережах." },
    ],
    footer_note: "Підтримуй українські ідеї 💙💛",
    footer: "Український проєкт для всього світу",
  },
  en: {
    brand: "E-PISNYA",
    tagline: "Your story will turn into a song",
    hero_headline_1: "Create songs",
    hero_headline_hl: "for any occasion",
    hero_line2: "for any occasion",
    hero_line3: "",
    tariffs_title: "TAP YOUR OPTION",
    tariffs_sub: "Three ways to create your song",
    plan_team_label: "MADE BY PROS",
    plan_team_title: "OUR STUDIO",
    plan_team_price: "1999 UAH",
    plan_team_desc: "A team of professional composers and sound engineers creates it by hand: several lyrics options and several sound versions in different genres and voices.",
    plan_bot_label: "TELEGRAM BOT",
    plan_bot_title: "CREATE VIA THE TELEGRAM APP",
    plan_bot_price: "169 UAH 🔥",
    plan_bot_desc: "Open Telegram and create your song in a handy app in just a few clicks!",
    plan_site_label: "CREATE ON THE SITE",
    plan_site_title: "CREATE RIGHT HERE",
    plan_site_price: "$29.99",
    plan_site_desc: "Create right here in the smart constructor: the song is generated automatically and sent to your email or messenger.",
    plan_click: "Tap",
    plan_eta_bot: "Ready in up to 5 min",
    plan_eta_team: "up to 24 hours",
    plan_eta_site: "Ready in up to 10 min",
    sounds_title: "SOUND OPTIONS",
    benefits: [
      { icon: "⚡", t: "Ready\nin 5 minutes" },
      { icon: "🎵", t: "Any\nstyle" },
      { icon: "❤️", t: "Perfect\nas a gift" },
    ],
    startup_badge: "Ukrainian tech startup",
    unites: "Music unites",
    nav_how: "How it works",
    nav_examples: "Examples",
    nav_pricing: "Pricing",
    nav_reviews: "Reviews",
    nav_admin: "Admin",
    nav_cta: "Launch the bot",
    nav_create: "Create",
    nav_instruction: "Instruction",
    nav_support: "Support",
    hero_badge: "hits already created",
    hero_title_1: "Create your hit",
    hero_title_hl: "in one click",
    hero_sub: "Lyrics · Music · Voice · Ready track",
    hero_cta: "Launch the bot",
    hero_cta_song: "Create a song",
    hero_note_left: "More Ukrainian music 💛",
    hero_note_right: "Your emotions have a sound 💙",
    create: {
      cta_sub: "Takes only 2 minutes",
      modal_title: "Choose an option",
      modal_sub: "Two ways to create your song",
      dev_title: "Team will create for you",
      dev_desc: "Our team will create the song for you — just describe your idea. We'll send the finished track.",
      dev_price: "699 UAH",
      dev_badge: "done for you",
      dev_eta: "Result within an hour",
      bot_title: "I'll create it in the bot",
      bot_desc: "Open the bot and go through 5 easy steps — song description, music, vocals.",
      bot_price: "169 UAH",
      bot_badge: "self-service",
      step_of: "Step {n} of 4",
      step_of8: "Step {n} of 8",
      back: "Back",
      next: "Next",
      b_ev_title: "What's the occasion?",
      b_ev_sub: "Choose the occasion",
      b_ev_custom_ph: "E.g. a song for my sister",
      b_genre_title: "Pick a music style",
      b_genre_sub: "Choose the genre",
      b_genre_more: "More genres",
      b_genre_mix: "Mix 2 genres",
      b_genre_custom: "Custom style / artist",
      b_mix_title: "Pick 2 genres to mix",
      b_mix_sub: "Choose exactly two — they blend into one style",
      b_mix_done: "Done",
      b_custom_title: "Custom style or artist",
      b_custom_sub: "Describe how the song should sound — e.g. like Coldplay",
      b_custom_ph: "E.g. warm acoustic guitar, 90s vibes",
      b_mood_title: "What mood should it have?",
      b_mood_sub: "Choose the mood",
      b_mood_custom: "Custom mood",
      b_mood_custom_ph: "Fiery, angry",
      b_lang_title: "Which language to sing in?",
      b_lang_sub: "Choose the song language",
      b_voice_title: "Which vocal do you prefer?",
      b_voice_sub: "Choose the voice",
      b_recommend: "Recommended",
      b_row_event: "Occasion",
      b_row_genre: "Genre",
      b_row_mood: "Mood",
      b_row_lang: "Language",
      sound_title: "Choose the sound",
      sound_sub: "What mood and style should your song have?",
      sounds: [
        { t: "Touching lyrics", d: "A lyrical, touching song with modern guitar and a crisp vocal — goosebumps guaranteed." },
        { t: "Pop (universal)", d: "Can be touching with modern beats, or danceable for the car or a party — fits almost anything." },
        { t: "R&B", d: "Melodic and touching, but more soulful and modern — a soft groove and warm vocals." },
        { t: "Dance", d: "This music makes you want to dance — a driving beat and festive energy." },
        { t: "Feast song", d: "Warm songs for fun and gatherings with friends — melodic, with folk motifs." },
        { t: "Light rock", d: "Masculine vibe, restrained power and adrenaline — for men, soldiers, those who like it stronger. No aggression." },
        { t: "Rock", d: "Guitar drive, live drums and energy — noticeably heavier than light rock, but not aggressive." },
        { t: "Rap / hip-hop", d: "A punchy beat and a rhythmic flow — modern, catchy, with character." },
        { t: "Deep house", d: "Calm late-night club music — soft bass, deep vibe and atmosphere." },
        { t: "Disney", d: "A fairy-tale cinematic song like in an animated movie — for kids and dreamers." },
        { t: "Disco / Nu-disco", d: "Fiery disco like an 80s dance floor — a groovy beat, bright synths and party energy." },
      ],
      vo_title: "Choose the performer",
      vo_sub: "Whose voice will sing your song?",
      voices: [
        { t: "Male", d: "Strong male vocal" },
        { t: "Female", d: "Tender female vocal" },
        { t: "Duet", d: "Male and female together" },
      ],
      desc_title: "Tell us about the song",
      desc_sub: "Write in your own words who the song is for and what it should be about. The quality of the song depends on this text. You can add a story, names and anything else.",
      desc_own_title: "Your lyrics",
      desc_own_sub: "Paste the finished lyrics. Everything you write will be sung word for word.",
      desc_gen_note: "The system will generate the lyrics based on your description.",
      desc_ph: "For example: a song for my mom's birthday. She devoted her whole life to us, loves the garden and embroidered shirts, her greatest happiness is when we are all together...",
      desc_lang_hint: "We'll sing in the language you write your description in",
      desc_example_btn: "Show an example",
      desc_example_hide: "Hide the example",
      desc_example: "«A song for my wife Anna turning 30. We've been together for 8 years, we have a daughter Solomia. Anna is my rock, she adores the sea and morning coffee. I want to thank her for her patience and say I love her more every day.»",
      story_attach: "Screenshot of the story",
      story_change: "Change",
      story_remove: "Remove",
      checkout_title: "Almost there",
      checkout_sub: "Just a few more details",
      co_sound: "Sound",
      co_brief: "About the song",
      co_total: "Amount to pay",
      price200: "$29.99 USD",
      co_eta: "Estimated song waiting time",
      co_eta_value: "up to 10 min",
      tier_title: "Choose the delivery speed",
      tier_standard: "Standard",
      tier_standard_eta: "24 hours",
      tier_standard_price: "699 UAH",
      tier_express: "Express",
      tier_express_eta: "6 hours",
      tier_express_price: "999 UAH",
      tier_urgent: "Urgent",
      tier_urgent_eta: "1 hour",
      tier_urgent_price: "1599 UAH",
      co_delivery: "Where should we send the song?",
      co_required: "required",
      co_delivery_hint: "Choose email, Telegram, WhatsApp or Instagram — leave the contact where we should send your finished song.",
      methods: { telegram: "Telegram", whatsapp: "WhatsApp", viber: "Viber", email: "Email", instagram: "Instagram" },
      contact_ph: {
        telegram: "@username or +1 555 123 4567",
        whatsapp: "+1 555 123 4567",
        viber: "+1 555 123 4567",
        email: "you@email.com",
        instagram: "@your_nickname",
      },
      co_show: "Show",
      co_hide: "Hide",
      co_edit: "Edit",
      co_details_title: "Order details",
      co_confirm: "Confirm",
      err_contact: "Please specify where to send the song.",
      err_phone: "Invalid number. Digits only, e.g. +1 555 123 4567",
      err_email: "Invalid email, e.g. you@email.com",
      err_telegram: "Enter a Telegram username (e.g. @username) or phone number.",
      err_instagram: "Enter a valid Instagram nickname, e.g. @your_nickname",
      studio_title: "Processing your order",
      studio_sub: "Sending your order to the studio…",
      support_cta: "Have questions? Message us",
      guarantee_q: "What if the song doesn't fit?",
      guarantee_a: "Our team of professionals works to the highest standard, but if any detail doesn't fit — we will redo it for you free of charge.",
      pay_title: "ALMOST THERE - PAYMENT!",
      pay_sub: 'Transfer the amount to our card, attach the receipt screenshot and tap "PAID" — our team will start creating the song!',
      pay_amount: "Amount to pay",
      pay_card: "Payment card",
      copy: "Copy",
      copied: "Copied ✓",
      loading_card: "Loading the payment details…",
      wallet_title: "PAYMENT",
      wallet_sub: "Choose Apple Pay or Google Pay — fast and secure.",
      wallet_choose: "How would you like to pay?",
      wallet_processing: "Processing your payment…",
      wallet_processing_sub: "This will take a few seconds.",
      wallet_error_title: "Temporary payment difficulties",
      wallet_error_text: "Don't worry — your song is safe. Leave your email and we'll contact you to start production.",
      wallet_contact_btn: "Contact us",
      wallet_form_title: "Leave your contact",
      wallet_form_sub: "We'll message you and start creating your song.",
      wallet_form_email: "Your email",
      wallet_form_message: "Comment (optional)",
      wallet_form_ph: "For example: I want a song for my mom...",
      wallet_form_send: "Send",
      wallet_form_sending: "Sending…",
      wallet_form_note: "We reply within 30 minutes during business hours.",
      wallet_sent_title: "Thank you!",
      wallet_sent_text: "We've received your contact and will reach out to start creating your song.",
      wallet_err_email: "Please enter a valid email.",
      wallet_err_message: "The comment must be at least 10 characters.",
      wallet_err_send: "Couldn't send your message. Please try again.",
      pay_receipt: "Payment screenshot",
      receipt_pick: "Attach the receipt (tap here)",
      receipt_change: "Change the receipt",
      receipt_hint: "Photo, screenshot or PDF of the receipt (up to 10 MB)",
      submit: "I have paid",
      submitting: "Sending…",
      summary_sound: "Sound",
      err_desc: "Please describe the song in more detail — at least 25 characters.",
      err_receipt: "Please attach the payment screenshot.",
      err_send: "Could not send the order. Please try again.",
      done_title: "Thank you!",
      done_sub: "Your order has been received",
      done_order: "Order #",
      done_note: "We will verify the payment and start creating your song right away. Take a screenshot of this page with the order number. You can track the order status right on the site — a status panel will appear at the bottom and update automatically.",
      done_close: "Close",
      done_contact: "Contact us",
    },
    pills: [
      { t: "No skills needed" },
      { t: "Any style" },
      { t: "For events & gifts" },
      { t: "Your ideas become songs" },
    ],
    sp_songs: "songs created",
    sp_rating: "satisfaction rating",
    sp_tears: "tears of joy",
    sp_speed: "min to create",
    how_title: "How it works",
    how_sub: "From idea to a finished song — in 5 steps",
    how_steps: [
      { t: "Pick occasion and style", d: "5 easy steps: occasion, genre, mood, language and voice." },
      { t: "Get lyrics FOR FREE", d: "AI writes personal song lyrics in a couple of minutes." },
      { t: "Listen to examples", d: "Real songs from our users — right on the site." },
      { t: "Pay easily", d: "A card transfer and a quick confirmation — the render starts." },
      { t: "Get your finished song", d: "The full track in 2 versions, in high quality." },
    ],
    ex_title: "Listen to examples",
    ex_sub: "Every hit is a unique story",
    examples: [
      { tag: "Acoustic × R&B", title: "For Mom", genre: "Acoustic × R&B",
        desc: "A letter of thanks to Mom — for the sleepless nights, the quiet sacrifices, and a home that always felt safe.",
        mood: "Heartfelt", voice: "Female vocal",
        badge: "60th Birthday", order: "#8900",
        art: "/design/events3d/birthday.webp",
        artBg: "radial-gradient(circle at 50% 38%, rgba(255,169,120,.58), rgba(123,55,122,.24) 43%, #0B1020 78%)",
        artGlow: "rgba(255,169,120,.34)",
        audio: "/media/audio/8900/eg54x64s/0.mp3" },
      { tag: "Soft Rock × Hip-Hop", title: "For Dad", genre: "Soft Rock × Hip-Hop",
        desc: "A soft-rock and rap confession for Dad — the words he never heard enough, wrapped in a warm baritone.",
        mood: "Heartfelt", voice: "Male vocal",
        badge: "Thank You", order: "#8843",
        art: "/design/events3d/thanks.webp",
        artBg: "radial-gradient(circle at 50% 38%, rgba(120,166,255,.55), rgba(116,61,155,.24) 44%, #0B1020 78%)",
        artGlow: "rgba(120,166,255,.34)",
        audio: "/media/audio/8843/y6zh1buw/0.mp3" },
      { tag: "Neo-Soul × R&B", title: "For Sister", genre: "Neo-Soul × R&B",
        desc: "A neo-soul ode to a sister who has always been your person — warm, honest, and full of heart.",
        mood: "Heartfelt", voice: "Female vocal",
        badge: "Her Person", order: "#7220",
        art: "/design/events3d/support.webp",
        artBg: "radial-gradient(circle at 50% 38%, rgba(255,135,190,.52), rgba(84,74,190,.28) 44%, #0B1020 78%)",
        artGlow: "rgba(255,135,190,.32)",
        audio: "/media/audio/7220/345unyho/0.mp3" },
      { tag: "🎸 Hard Rock", title: "For a Brother", genre: "Hard Rock",
        desc: "An arena-rock birthday anthem for a cop brother — long shifts, loyalty, and a friendship that always has his back.",
        mood: "Energetic", voice: "Male vocal",
        badge: "Birthday", order: "#2197",
        art: "/design/events3d/birthday.webp",
        artBg: "radial-gradient(circle at 50% 38%, rgba(255,145,95,.58), rgba(130,35,75,.24) 43%, #0B1020 78%)",
        artGlow: "rgba(255,145,95,.34)",
        audio: "/media/audio/2197/hkp8xp6n/0.mp3" },
      { tag: "💞 Pop", title: "For a Partner", genre: "Pop",
        desc: "A love letter from a woman to the man she chose — from teenage years to building a family together.",
        mood: "Romantic", voice: "Female vocal",
        badge: "Love Story", order: "#6799",
        art: "/design/events3d/anniv.webp",
        artBg: "radial-gradient(circle at 50% 38%, rgba(255,150,190,.55), rgba(90,70,180,.25) 44%, #0B1020 78%)",
        artGlow: "rgba(255,150,190,.32)",
        audio: "/media/audio/6799/7owbx71r/0.mp3" },
      { tag: "🌊 Deep House", title: "For Dad", genre: "Deep House",
        desc: "A daughter-and-son duet thanking Dad for a lifetime of sacrifice — for his 75th birthday.",
        mood: "Heartfelt", voice: "Duet",
        badge: "75th Birthday", order: "#7698",
        art: "/design/events3d/support.webp",
        artBg: "radial-gradient(circle at 50% 38%, rgba(180,150,255,.55), rgba(70,80,180,.28) 44%, #0B1020 78%)",
        artGlow: "rgba(160,130,255,.34)",
        audio: "/media/audio/7698/dkncgzlh/0.mp3" },
      { tag: "🪩 Disco", title: "For a Cousin", genre: "Disco",
        desc: "A funky disco birthday anthem for a cousin who brings the whole family together.",
        mood: "Fun", voice: "Male vocal",
        badge: "40th Birthday", order: "#9896",
        art: "/design/events3d/birthday.webp",
        artBg: "radial-gradient(circle at 50% 38%, rgba(255,196,80,.55), rgba(130,50,160,.25) 44%, #0B1020 78%)",
        artGlow: "rgba(255,196,80,.32)",
        audio: "/media/audio/9896/bc320wcz/0.mp3" },
    ],

    ex_play: "Play",
    ex_playing: "Playing 🎧",
    pricing_title: "Choose your package",
    pricing_sub: "One song — one simple price. No subscription.",
    pricing_popular: "Most popular",
    pricing_cta: "Create a song",
    pricing_features: ["Free lyrics", "Studio quality", "Your own song", "Up to 5 min generation"],
    creators_btn: "🎬 For creators",
    creators_title: "For creators and business",
    creators_sub: "Large generation packs — for studios, agencies and those who make songs to order.",
    creators_cta: "Discuss in the bot",
    sticky_cta: "Create a song",
    referral_title: "Partner program",
    referral_sub: "Earn as a full partner of the project — 50% of the income from every purchase your referrals make. Share your link anywhere: social media, blog, ads.",
    referral_cta: "Become a partner",
    reviews_title: "What clients say",
    reviews_leave: "Leave a review",
    reviews_empty: "Customer reviews will appear here soon…",
    review_modal_title: "Your review",
    review_modal_sub: "Share your impressions — the review appears on the site after moderation.",
    review_name_ph: "Your name",
    review_text_ph: "How did the song turn out? What did you like?",
    review_send: "Send",
    review_sent_title: "Thank you!",
    review_sent_text: "Your review was sent for moderation — it will appear on the site shortly.",
    review_err_name: "Enter your name (at least 2 characters)",
    review_err_text: "Write a review (at least 10 characters)",
    review_err_send: "Could not send, please try again",
    review_close: "Close",
    support_modal_title: "How can we help?",
    support_modal_sub: "Ask our support team a question and we'll get back to you shortly.",
    support_email: "Your email",
    support_email_ph: "you@email.com",
    support_question: "Your question",
    support_question_ph: "Tell us what you need help with…",
    support_send: "Send message",
    support_sending: "Sending…",
    support_sent_title: "Message sent",
    support_sent_text: "Our support team will get back to you shortly.",
    support_note: "We reply within 30 minutes during business hours.",
    support_err_email: "Enter a valid email address.",
    support_err_text: "Please write your question (at least 10 characters).",
    support_err_send: "Could not send your message. Please try again.",
    support_close: "Close",
    last_creation: "Your latest creation",
    last_orders_title: "Your orders",
    last_hint: "Continue right where you left off",
    last_continue: "Continue",
    last_open_song: "Open the song",
    st_unpaid: "unpaid",
    st_pending: "under review",
    st_generating: "generating",
    st_paid: "in the studio",
    st_done: "completed",
    st_expired: "expired",
    st_rejected: "declined",
    quality_title: "Quality guarantees",
    quality_sub: "We are with you at every step, from idea to finished song",
    quality: [
      { icon: "regen", t: "Free regeneration", d: "If something is off, we will always meet you halfway and regenerate the song for free as fast as possible." },
      { icon: "bot", t: "AI-powered studio", d: "Our AI handles everything — from the lyrics to the finished song with vocals." },
      { icon: "support", t: "Support always online", d: "If anything is unclear, our support team is online and will solve any question." },
      { icon: "person", t: "Personal help", d: "We are ready to help you at every step and fine-tune the song to your wishes." },
    ],
    quality_slogan: "The client always comes first for us",
    faq_title: "FAQ",
    faq: [
      { q: "Which language will the song be in?", a: "English and any other language. You choose the song language during creation — our AI will sing in the language of your story." },
      { q: "How long does it take?", a: "Lyrics take a couple of minutes, the ready track with vocals up to 3 minutes." },
      { q: "Can I download the song?", a: "Yes, after our team confirms your payment, the finished song is sent to your email or messenger." },
      { q: "Can I order a cover or a postcard?", a: "Yes, for all our clients we can make a postcard with your photo or the recipient's photo. Free with a song purchase." },
      { q: "What if I don't like the track or something went wrong?", a: "Our AI generates very high-quality songs. But if something is off, or you don't like the genre, the lyrics or the music, contact our support. We will regenerate it with your wishes for free." },
      { q: "I don't know which genre fits. What should I do?", a: "The constructor shows a hint with the most popular genres for every occasion. But you can experiment or ask our support." },
      { q: "I like a certain artist. Can the song be in their style?", a: "Yes. At the genre step choose «Custom style / artist» and simply type the artist's name whose style you want. Our AI will match the sound automatically." },
      { q: "I have my own lyrics. Can you make a song from them?", a: "Yes, you can send your own words. Our AI will polish them and build a full singable song around them." },
      { q: "What if I don't have any lyrics?", a: "Just describe what the track should be about. For example the facts: a name, secrets, personal moments you want to hear in the song. We take care of the rest." },
      { q: "Who owns the rights?", a: "The song is made for you — gift it, share it, post it on social media." },
    ],
    footer_note: "Support Ukrainian ideas 💙💛",
    footer: "A Ukrainian project for the whole world",
  },
};
